import React, { useLayoutEffect } from 'react';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { Helmet } from 'react-helmet';
import { Container } from '@openedx/paragon';
import { StudioFooter } from '@edx/frontend-component-footer';

import Header from '../header';
import messages from './messages';
import AccessibilityBody from './AccessibilityBody';
import AccessibilityForm from './AccessibilityForm';
import CustomFooter from '../custom-footer/custom-footer';

const AccessibilityPage = ({
  // injected
  intl,
}) => {
  const communityAccessibilityLink = 'https://www.edx.org/accessibility';
  const email = 'accessibility@edx.org';

  useLayoutEffect(() => {
    const updateMinHeight = () => {
      const headerHeight = (/** @type {HTMLElement} */ (document.querySelector(".studio-header")))?.offsetHeight || 0;
      const footerHeight = (/** @type {HTMLElement} */ (document.querySelector("footer")))?.offsetHeight || 0;


      const mainContent = document.querySelector("main");
      if (mainContent instanceof HTMLElement) {
        mainContent.style.minHeight = `calc(100vh - ${headerHeight + footerHeight}px)`;
      }
    };

    updateMinHeight();
    window.addEventListener("resize", updateMinHeight);

    return () => window.removeEventListener("resize", updateMinHeight);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage(messages.pageTitle, {
            siteName: process.env.SITE_NAME,
          })}
        </title>
      </Helmet>
      <Header isHiddenMainMenu />
      <main>
        <Container size="xl" classNamae="px-4">
          <AccessibilityBody {...{ email, communityAccessibilityLink }} />
          <AccessibilityForm accessibilityEmail={email} />
        </Container>
      </main>
      {/* <StudioFooter /> */}
      <CustomFooter />
    </>
  );
};

AccessibilityPage.propTypes = {
  // injected
  intl: intlShape.isRequired,
};

export default injectIntl(AccessibilityPage);
